import { createStore } from 'vuex';

import onboardingStore from './hummer/onboarding.js';
import jobStore from './job.ts';
import generalStore from './general.js';

const store = createStore({
  modules: {
    onboarding: onboardingStore,
    job: jobStore,
    general: generalStore,
  },
});

export default store;
